/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import Header from "components/common_components/Header";
import LoadingPage from "components/common_components/LoadingPage";
import Page from "components/common_components/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";
import RequestTypesContainer from "./components/RequestTypes";
import ClientsContainer from "./components/Clients";
import ChainOfCustodyContext from "./ChainOfCustodyContext";
import ClientSummary from "./components/ClientSummary";
import RequestTypesSummaryContainer from "./components/RequestTypesSummary";
import { Form } from "components/common_components/Formik";
import { hasElements } from "utils/arrays";
import FileCasesContainer from "./components/FileCases";
import FileCaseSummary from "./components/FileCaseSummary";

const AddWizard = () => {
    const history = useHistory();
    const { path } = useRouteMatch();
    const dispatch = useDispatch();
    const [resources, setResources] = useState({
        requestTypes: [],
    });
    const [isLoading, setIsLoading] = useState(false);
    const [requestType, setRequestType] = useState(null);
    const [client, setClient] = useState(null);
    const [fileCase, setFileCase] = useState(null);

    const [clientsContainerVisible, setClientsContainerVisible] = useState(true);
    const [clientSummaryContainerVisible, setClientSummaryContainerVisible] = useState(false);
    const [fileCaseContainerVisible, setFileCaseContainerVisible] = useState(false);
    const [fileCaseSummaryContainerVisible, setFileCaseSummaryContainerVisible] = useState(false);
    const [requestTypesContainerVisible, setRequestTypesContainerVisible] = useState(false);
    const [requestTypesSummaryContainerVisible, setRequestTypesSummaryContainerVisible] = useState(false);

    const { CocRequests, RequestTypes, addFormState, setAddFormState, fileCaseFilter } = useContext(ChainOfCustodyContext);

    const getResources = () => {
        setIsLoading(true);
        RequestTypes.getAll({
            onSuccess: (data) => {
                setResources((prev) => ({
                    ...prev,
                    requestTypes: data,
                }));
                setIsLoading(false);
            },
            onError: (error) => {
                setResources((prev) => ({ ...prev, requestTypes: [] }));
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    };

    useEffect(() => {
        getResources();
    }, []);

    useEffect(() => {
        if (fileCaseFilter) {
            handleClientSelected(fileCaseFilter.client);
            handleFileCaseSelected({
                fileCaseId: fileCaseFilter.fileCaseId,
                fileNo: fileCaseFilter.fileNo,
                module: fileCaseFilter.module,
            });
        }
    }, [fileCaseFilter]);

    const handleClientSelected = (client) => {
        setClient(client);
        setAddFormState((prev) => ({
            ...prev,
            client,
        }));
        setClientsContainerVisible(false);
        setClientSummaryContainerVisible(true);
        setFileCaseContainerVisible(true);
        setFileCaseSummaryContainerVisible(false);
    };
    const handleFileCaseSelected = (fileCase) => {
        setFileCase(fileCase);
        setAddFormState((prev) => ({
            ...prev,
            fileCase,
        }));
        setFileCaseContainerVisible(false);
        setFileCaseSummaryContainerVisible(true);
        setRequestTypesContainerVisible(true);
        setRequestTypesSummaryContainerVisible(false);
    };
    const handleRequestTypeSelected = (requestType) => {
        setRequestType(requestType);
        setAddFormState((prev) => ({
            ...prev,
            requestType,
        }));
        setRequestTypesContainerVisible(false);
        setRequestTypesSummaryContainerVisible(true);
    };
    const handleClientSummaryBackClick = () => {
        setClient(null);
        setFileCase(null);
        setRequestType(null);
        setClientsContainerVisible(true);
        setClientSummaryContainerVisible(false);
        setFileCaseContainerVisible(false);
        setFileCaseSummaryContainerVisible(false);
        setRequestTypesContainerVisible(false);
        setRequestTypesSummaryContainerVisible(false);
        setAddFormState((prev) => ({
            ...prev,
            client: null,
            fileCase: null,
            requestType: null,
        }));
    };

    const handleFileCaseSummaryBackClick = () => {
        setFileCase(null);
        setRequestType(null);
        setFileCaseSummaryContainerVisible(false);
        setFileCaseContainerVisible(true);
        setRequestTypesContainerVisible(false);
        setRequestTypesSummaryContainerVisible(false);
        setAddFormState((prev) => ({
            ...prev,
            fileCase: null,
            requestType: null,
        }));
    };

    const handleRequestTypesSummaryBackClick = () => {
        setRequestType(null);
        setRequestTypesContainerVisible(true);
        setRequestTypesSummaryContainerVisible(false);
        setAddFormState((prev) => ({
            ...prev,
            requestType: null,
        }));
    };
    const handleRequestTypesContainerBackClick = handleFileCaseSummaryBackClick;

    function onSuccess(newId, setSubmitting) {
        setSubmitting(false);
        dispatch(notifySuccess(`Request created successfully!`));
        history.push(`${path}/${newId}`);
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    const handleSubmit = (_, { setSubmitting, setErrors }) => {
        setSubmitting(false);
        setErrors({});

        if (!client) {
            setErrors({ client: "Client is required." });
            dispatch(notifyError("Client is required."));
            return;
        }

        if (client && !fileCase) {
            setErrors({ fileCase: "Case is required." });
            dispatch(notifyError("Case is required."));
            return;
        }

        if (!addFormState.requestType) {
            setErrors({ requestType: "Request type is required." });
            dispatch(notifyError("Request type is required."));
            return;
        }

        if (!hasElements(addFormState.requestType.evidenceDocTypes)) {
            setErrors({ evidenceDocTypes: "At least 1 evidence is required." });
            dispatch(notifyError("At least 1 evidence is required."));
            return;
        }

        CocRequests.add({
            payload: {
                id: null,
                status: "pending",
                clientId: client.id,
                settingsCocRequestTypesId: requestType.id,
                evidences: addFormState.requestType.evidenceDocTypes.map((evidence) => ({
                    id: null,
                    cocRequestsId: null,
                    description: evidence.descriptionOverride,
                    settingsCocEvidenceDocTypesId: evidence.settingsCocEvidenceDocTypesId,
                })),
                module: fileCase.module,
                fileNo: fileCase.fileNo,
                fileCaseId: fileCase.fileCaseId,
            },
            onSuccess: (newId) => onSuccess(newId, setSubmitting),
            onError: (error) => onError(error, setSubmitting, setErrors),
        });
    };

    return (
        <Page className="add-coc-wizard-page">
            <Header title="Create request" />
            {isLoading && <LoadingPage />}
            {!isLoading && (
                <Form onSubmit={handleSubmit} onCancel={history.goBack}>
                    {(form) => (
                        <div className="container">
                            {!fileCaseFilter && (
                                <>
                                    <ClientsContainer
                                        visible={clientsContainerVisible}
                                        onBackClick={history.goBack}
                                        onClientSelected={handleClientSelected}
                                        error={form.errors?.client}
                                    />
                                    <ClientSummary
                                        visible={clientSummaryContainerVisible}
                                        client={client}
                                        onBackClick={handleClientSummaryBackClick}
                                    />
                                    <FileCasesContainer
                                        visible={fileCaseContainerVisible}
                                        client={client}
                                        onFileCaseSelected={handleFileCaseSelected}
                                        onBackClick={handleClientSummaryBackClick}
                                        error={form.errors?.fileCase}
                                    />
                                    <FileCaseSummary
                                        visible={fileCaseSummaryContainerVisible}
                                        fileCase={fileCase}
                                        onBackClick={handleFileCaseSummaryBackClick}
                                    />
                                </>
                            )}

                            <RequestTypesContainer
                                requestTypes={resources.requestTypes}
                                visible={requestTypesContainerVisible}
                                onClick={handleRequestTypeSelected}
                                onBackClick={handleRequestTypesContainerBackClick}
                                error={form.errors?.requestType}
                            />
                            <RequestTypesSummaryContainer
                                visible={requestTypesSummaryContainerVisible}
                                requestType={requestType}
                                onBackClick={handleRequestTypesSummaryBackClick}
                                onEvidencesChanged={(evidenceDocTypes) => {
                                    setAddFormState((prev) => ({
                                        ...prev,
                                        requestType: {
                                            ...prev.requestType,
                                            evidenceDocTypes,
                                        },
                                    }));
                                }}
                                error={form.errors?.evidenceDocTypes}
                            />
                        </div>
                    )}
                </Form>
            )}
        </Page>
    );
};

export default AddWizard;
